import {
  ButtonGroup,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import Button from 'common/components/button';
import { ModalButtons } from 'common/components/modal-buttons';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import WhatsNextQuote from 'components/plan-quote/quote-whats-next';

const SaveQuoteModal = ({ planData, isOpen, onClose }) => {
  const navigate = useNavigate();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      size={{ base: 'full', md: '2xl' }}
    >
      <ModalOverlay />
      <ModalContent className='overflow-clip'>
        <ModalHeader className='text-xl font-medium border-b border-gray-200'>
          Your quote has been saved!
        </ModalHeader>
        <ModalBody className='flex flex-col gap-4 py-6'>
          <Text className='text-base text-gray-500'>
            Your quote for early move out coverage at{' '}
            {planData?.property?.name ||
              planData?.lease?.address?.streetAddress1}{' '}
            has been saved! You should receive an email shortly with a summary.
          </Text>
          <Text className='text-base text-gray-500'>
            Create as many quotes as you’d like and find them all on the{' '}
            <span className='font-semibold'>Plans page</span> of your account
            dashboard. Return anytime to view, edit, or purchase.
          </Text>
          <Flex id='whats-next' className='mt-2 border-t border-gray-200'>
            <Flex className='flex-col gap-6 w-full pt-6'>
              <Flex className='flex-col sm:flex-row sm:justify-between gap-3 sm:items-center'>
                <h2 className='text-lg font-medium'>What's Next?</h2>
              </Flex>
              <WhatsNextQuote planData={planData} />
            </Flex>
          </Flex>
        </ModalBody>
        <ModalButtons>
          <Button
            title='Back to Quote'
            onClick={onClose}
            wFull={false}
            theme='secondary'
          />
          {/* <Button
            title='Purchase Now'
            onClick={() => navigate(`/dashboard/plans/purchase/${planData.id}`)}
            wFull={false}
            theme='secondary'
          /> */}
          <Button
            title='Go to Plans'
            onClick={() => {
              onClose();
              navigate('/dashboard/plans?tab=quotes');
            }}
            wFull={false}
            theme='primary'
          />
        </ModalButtons>
      </ModalContent>
    </Modal>
  );
};

const SaveQuoteButton = ({ planData, size }) => {
  const [saveQuoteModal, setSaveQuoteModal] = useState(false);
  return (
    <div>
      <Button
        title='Save Quote'
        onClick={() => setSaveQuoteModal(true)}
        wFull={false}
        theme='secondary'
        size={size}
      />
      {saveQuoteModal && (
        <SaveQuoteModal
          planData={planData}
          isOpen={saveQuoteModal}
          onClose={() => setSaveQuoteModal(false)}
        />
      )}
    </div>
  );
};

export default SaveQuoteButton;
